var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0001 5.89L10.6094 3.5L12.0001 2.10933L14.3908 4.5L13.0001 5.89ZM4.98475 13.906L1.63742 14.862L2.59408 11.5153L9.66675 4.44267L12.0574 6.83333L4.98475 13.906ZM16.0001 4.5C16.0001 4.32133 15.9308 4.154 15.8048 4.02867L12.4714 0.695333C12.3474 0.570667 12.1761 0.5 12.0001 0.5C11.8241 0.5 11.6528 0.570667 11.5288 0.695333L9.66675 2.55667L8.72408 3.5L1.52875 10.6953C1.44542 10.7787 1.39875 10.88 1.36875 10.986L1.35942 10.9833L0.026084 15.65C-0.0412493 15.8827 0.024084 16.1327 0.195417 16.3047C0.367417 16.476 0.617417 16.5407 0.850084 16.474L5.51675 15.1407L5.51408 15.1313C5.62008 15.1013 5.72142 15.0547 5.80475 14.9713L13.0001 7.776L13.9428 6.83333L15.8048 4.97133C15.9308 4.84533 16.0001 4.678 16.0001 4.5Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.85430ca7577a7e2f7354bf0c2dcc3a21.svg";
export { ForwardRef as ReactComponent };